import type { FaireProductEntity } from "../../entity_types/product";

export const p_w3uj4uemxp: FaireProductEntity = {
  token: "p_w3uj4uemxp",
  type: "product",
  name: "Mountain Valley Spring Water 1 Liter",
  brandToken: "b_9z8pu8jvce",
  brandName: "Rising Sun Distributors",
  imageUrl:
    "https://cdn.faire.com/fastly/73b533053ea21516fd070f1d0eaed99ec8d6602986c69fd45f45a909e768335b.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b9e5fb167b617e671a77b313e380db6962569374a669f62cae5fa1666863479.jpeg",
  ],
  priceDollars: 5.07,
  description:
    "Since 1871, Mountain Valley has been delivering pure, premium spring water straight from the Ouachita Mountains. Naturally alkaline, sodium-free, and mineral-rich, this water offers a crisp, refreshing taste that keeps customers coming back.\n\nThis 1 liter glass format is perfect for family tables, restaurants, cafes, gyms, and wellness-focused retailers who want to offer their customers more value per bottle. The larger size means better hydration, fewer single-use bottles, and a premium experience at an accessible price point.",
  tags: [],
  msrpDollars: 10.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:40.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
